const GiftDataCol = [
  {
    id: 'id',
    numeric: false,
    disablePadding: true,
    label: 'ID',
  },
  {
    id: 'name',
    numeric: false,
    disablePadding: false,
    label: 'Name',
  },
  {
    id: 'description',
    numeric: false,
    disablePadding: false,
    label: 'Description',
  },
  {
    id: 'mrp',
    numeric: true,
    disablePadding: false,
    label: 'MRP',
  },
  {
    id: 'points',
    numeric: true,
    disablePadding: false,
    label: 'Points',
  },
  {
    id: 'is_active',
    numeric: false,
    disablePadding: false,
    label: 'Is Active',
  },
  {
    id: 'deleted_at',
    numeric: false,
    disablePadding: false,
    label: 'Deleted At',
  },
  {
    id: 'created_at',
    numeric: false,
    disablePadding: false,
    label: 'Created At',
  },
  {
    id: 'updated_at',
    numeric: false,
    disablePadding: false,
    label: 'Updated At',
  },
  {
    id: 'actions',
    numeric: false,
    disablePadding: false,
    label: 'Actions',
  },
];

export default GiftDataCol;
